import { useEffect, useState } from 'react';
import './style.css'
function ToggleButton({enableValue}){
   const [isEnabled, setIsEnabled] = useState(true);
   useEffect(()=>{
     enableValue(isEnabled)

   },[isEnabled])
  const handleToggle = () => {
    setIsEnabled((prev) => !prev);
  };

    return(
        <>
                      <div className="flex items-start space-x-3">
                        <div className='flex flex-row-reverse md:flex-row md:space-x-3'>


  <span className={`text-xs md:text-base mt-1 -ml-3 md:ml-0 font-bold ${isEnabled ? 'text-[#2c9333]' : 'text-[#FF7518]'}`}>
        {isEnabled ? "Enabled" : "Disabled"}
      </span>
        <div>

<label className="toggle-switch">
  <input type="checkbox" defaultChecked             onChange={handleToggle}
/>
  <div className="toggle-switch-background">
    <div className="toggle-switch-handle"></div>
  </div> 
</label>
        </div>

                        </div>
</div>
        </>
    )
}

export default ToggleButton